module.exports = __webpack_public_path__ + "static/media/dashboard_icon.ba24fb9f.svg";